import React, { useEffect, useState } from "react";
import classes from "./DiagnosisList.module.scss";
import Header from "../../molecules/header/Header";
import TopHeader from "../../organism/top-header/TopHeader";
import PointHeader from "../../organism/point-header/PointHeader";
import DiagnosisCard from "../../organism/diagnosis-card/DiagnosisCard";
import BreadCrumb from "../../molecules/breadcrumb/BreadCrumb";
import TeacherComment from "../../molecules/teacher-commnet/TeacherComment";
import rabbitNormal from "../../static/images/rabbit-normal.png";
import { fetchSimulationList } from "../../api/SimulationListApi";
import { useNavigate } from "react-router-dom";
import { fetchUser } from "../../api/UsersApi";
import { isCompareInputCompleted } from "../../common/utility/compare.util";

const DiagnosisList = () => {
  const navigate = useNavigate();
  const simulationApi = fetchSimulationList();
  const userApi = fetchUser();
  const [compareStartRequested, setCompareStartRequested] = useState(false);
  
  useEffect(() => {
    simulationApi.fetch();
    userApi.fetch();
    }, []);

  const navigateByCompareInputStatus = () => {
    navigate(
      isCompareInputCompleted(userApi.state?.data?.[0])
        ? "/comparenavi/result"
        : "/comparenavi/input"
    );
  };
  
  const navigateCompare = () => {
    if (userApi.state?.status === "success") {
      navigateByCompareInputStatus();
      return;
    }

    setCompareStartRequested(true);
    if (userApi.state?.status !== "processing") {
      userApi.fetch();
    }
  };

  useEffect(() => {
    if (!compareStartRequested) return;
    if (userApi.state?.status !== "success") return;

    setCompareStartRequested(false);
    navigateByCompareInputStatus();
  }, [compareStartRequested, userApi.state]);

  return (
    <>
      <div className={classes.container}>
        <Header />
        <TopHeader currentMenuUrl="/diagnosis-list" />
        <PointHeader aquiredPoint={userApi.state?.data?.[0]?.currentPoint ?? 0} />
        <div className={classes.comment}>
          <TeacherComment
            image={rabbitNormal}
            bgWhite={true}
            comment={[
              "心理学や統計学の専門家とつくったオリジナル診断です。",
              "新たな発見をお楽しみください♪",
            ]}
          />
        </div>
        <div className={classes.diagnosisContents}>
          {simulationApi.state?.data?.map((d, index) => {
            return (
              <div className={classes.diagnosisBlock} key={index}>
                <DiagnosisCard
                  summary={d.summary}
                  tag={d.tag}
                  imageData={d.imageData}
                  internalUrl={d.simulationId === "sim_compare" ? "" : d.internalUrl}
                  callback={
                    d.simulationId === "sim_compare"
                      ? navigateCompare
                      : d.externalUrl != null && d.externalUrl !== ""
                      ? () => {
                          navigate(
                            `/diagnosis-external?type=simulation&id=${d.simulationId}`
                          );
                        }
                      : undefined
                  }
                  done={d.isChallenged}
                  type="diagnosis"
                  index={index}
                  expectedTime={d.expectedTime}
                  />
              </div>
            );
          })}
        </div>
        <BreadCrumb
          data={[
            { displayName: "みらいいコンシェル" },
            { displayName: "診断" },
          ]}
        />
      </div>
    </>
  );
};

export default DiagnosisList;
